import { type ReactNode } from 'react'
import * as GridLayout from '@/components/GridLayout/GridLayout'

export function InsuranceGuideBlockContainer({ children }: { children: ReactNode }) {
  return (
    <GridLayout.Root>
      <GridLayout.Content width="1/2" align="center">
        {children}
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
